module.exports = __webpack_public_path__ + "media/g-2.d25557e3.mp3";